import React from 'react';


const boxes = [
    [['vehicule'],'Votre véhicule'],
    [['vous'],'Vous'],
    [['antecedents'],'Vos antécédents'],
    [['landing'],'Choix de la formule'],
    [['details1'],'Confirmation'],
    [['payment'],'Paiement'],
    [['subscribing','subscribe_error','presubscribe_error','cancelled'],'Souscription']
]

const processBoxes = [
    [['details1'],'Confirmation'],
    [['payment'],'Paiement'],
    [['subscribing','subscribe_error','presubscribe_error','cancelled'],'Souscription'],
    [['paid_subscribed'],'Souscription validée']
]

const processPages = ['subscribing','subscribe_error','presubscribe_error','cancelled','paid_subscribed']


class FrontProgressBox extends React.Component {
    constructor(props) {
        super(props)
    }

    onClick() {
        if ( this.props.future < 0 ) {
            this.props.setPage(this.props.toPage)
        } else if (( this.props.future >= 1 )&&( this.props.toPage != 'subscribing' )) {
            if ( this.props.onSubmit ) this.props.onSubmit()
        }
    }

    render() {
        if ( this.props.selected ) return <div className="progress_box selected">{this.props.title}</div>
        if ( this.props.future > 0 ) return <div className="progress_box future" onClick={this.onClick.bind(this)}>{this.props.title}</div>
        return <div className="progress_box" onClick={this.onClick.bind(this)}>{this.props.title}</div>
    }
}

export default class FrontProgress extends React.Component {

    constructor(props) {
        super(props);
    }

    renderBoxes(list) {
        let future = -1
        return list.map( entry => {
            const [pages,title] = entry
            const selected = pages.includes(this.props.page)
            if ( selected ) future = 0
            else {
                if ( future >= 0 ) future += 1
            }
            return <FrontProgressBox onSubmit={this.props.onSubmit} key={pages} toPage={pages[0]} title={title} selected={selected} future={future} setPage={this.props.setPage}/>
        })
    }

    showBoxes() {
/*        if (( ! this.props.comparateursCompleted )
            ||( this.props.page=='landing' )
            ||( this.props.page=='details1' ))
                return comparateursBoxes */
        if ( processPages.includes(this.props.page) ) return processBoxes
        return boxes;
    }

    render() {
        return <div className="titlebox" ref={this.props.topRef}>
            {this.renderBoxes(this.showBoxes())}
        </div>
    }
}
